import React, { useState, useEffect } from "react";
import { Mail, MessageSquare } from "react-feather";
import { UncontrolledDropdown, DropdownToggle, UncontrolledTooltip } from "reactstrap";
import { Link } from "react-router-dom";
import axios from "axios";

const ChatMess = () => {
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    const checkConnection = async (uuid) => {
      try {
        const response = await axios.get(
          `https://convert.cloodo.com/check-connect-waba?uuid=${uuid}&_=${Date.now()}`
        );
        if (response.data && response.data.connect) {
          setIsConnected(true);
        }
      } catch (error) {
        console.error("Error checking connection:", error);
      }
    };

    const userDataString = localStorage.getItem("userData");
    if (userDataString) {
      try {
        const userData = JSON.parse(userDataString);
        const uuid = userData.id;
        if (uuid) {
          checkConnection(uuid);
        }
      } catch (error) {
        console.error("Error parsing userData from localStorage:", error);
      }
    }
  }, []);

  return (
    <div style={{ position: 'relative' }} id="chat-mess-container">
      <UncontrolledDropdown
        href="/"
        tag="li"
        className="dropdown-language nav-item"
        style={{
          border: "1px solid #E7E3E3",
          padding: "4px",
          borderRadius: "5px",
        }}
      >
        <DropdownToggle to="/apps/message" tag={Link} className="nav-link">
          <span className="selected-language">
            <MessageSquare size={18} /> Chat
          </span>
        </DropdownToggle>
      </UncontrolledDropdown>
      
      <div
        style={{
          position: 'absolute',
          top: '-5px',
          right: '-5px',
          width: '12px',
          height: '12px',
          borderRadius: '50%',
          backgroundColor: isConnected ? '#28C76F' : '#EA5455',
          border: '2px solid #fff'
        }}
      />

      <UncontrolledTooltip
        placement="top"
        target="chat-mess-container"
      >
        {isConnected 
          ? 'WhatsApp Connected' 
          : 'WhatsApp Not Connected - Click to configure WhatsApp integration'
        }
      </UncontrolledTooltip>
    </div>
  );
};

export default ChatMess;
